import React, { Component } from 'react';

import SEO, { breadcrumbSchema } from '../common/SEO';
import Header from '../common/Header';
import Footer from '../common/Footer';
import SelfSpiel from '../common/SelfSpiel';
import ModalSuccess from '../common/ui/ModalSuccess';
import ModalError from '../common/ui/ModalError';

import ContactForm from './contact/ContactForm';
import Preloader from '../../hocs/Preloader';

const CONTACT_JSON_LD = breadcrumbSchema([
  { name: "Home", path: "/" },
  { name: "Contact", path: "/contact" },
]);

class Contact extends Component {
  render() {
    return (
      <div id="page-container" className="full-height">
        <SEO
          title="Contact Fernan de Dios"
          description="Get in touch with Fernan de Dios to discuss SaaS products, AI/LLM integrations, product development, or technical leadership collaboration."
          path="/contact"
          jsonLd={CONTACT_JSON_LD}
        />
        <Header id="contact-banner" title="Get in Touch" sub="Interested in working together? Send me a message and I will get back to you as soon as possible!" />
        <ContactForm />
        <SelfSpiel />
        <Footer />
        <ModalSuccess />
        <ModalError />
      </div>
    );
  }
}

export default Preloader(Contact);
